import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "react-datepicker/dist/react-datepicker.css";
import instance from "../../../WebApi/WebApi";
import { getSuppliersList } from "../../../service/Suppliers/SuppliersService";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import PurchaseTable from "./PurchaseTable";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import SpinnerComponent from "../../components/SpinnerComponent";
import { debounce } from "lodash";

const Purchaseorderlist = () => {
  const { t } = useTranslation();
  const [isActive, setActive] = useState("false");
  const [isDraft, setIsDraft] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleToggle = () => {
    setActive(!isActive);
  };

  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [allPurchaseData, setAllPurchaseData] = useState([]);
  const [SupplierDataList, setAllSupplierDataList] = useState([]);
  const [businesUnitData, setAllBusinessUnit] = useState([]);
  const [myDepartmentList, setAllMyDepartmentList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [bUnit, setBUnit] = useState([]);
  const [department, setDepartment] = useState([]);

  useEffect(() => {
    getPurchaseOrderList();
  }, [isDraft]);
  useEffect(() => {
    getPurchaseOrderList();
    getInvoiceSupplierDataList();
    getBussinessUnit();
  }, []);

  //list of suppliers
  async function getInvoiceSupplierDataList() {
    getSuppliersList().then(function (result) {
      const response = result?.data;
      setAllSupplierDataList(response?.data?.listSupplier);
    });
  }

  async function getBussinessUnit() {
    getAllIndustryDetailslist("").then(function (result) {
      const response = result.data;
      setAllBusinessUnit(response?.data);
    });
  }

  const getPurchaseOrderList = async () => {
    setIsLoading(true);
    const data = {
      isDraft: isDraft,
      businessUnitId: bUnit,
      departmentId: department,
      supplierId: supplier,
      fromDate: startDate,
      toDate: endDate,
    };
    try {
      const response = await instance.post(
        `/customer/purchase-order/list-purchase-order?searchKeyword=${searchText}`,
        data
      );
      setAllPurchaseData(response?.data?.data?.listPastOrder);
      //  console.log("response", response);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const getDepartmentList = async (id) => {
    const data = {
      businessUnitId: id,
    };
    const response = await instance.post(
      `/customer/department/list-department-business-id`,
      data
    );
    setAllMyDepartmentList(response?.data?.data?.departmentList);
  };

  const handleDropdown = (id) => {
    setSupplier(id ? [Number(id)] : []);
    //  console.log("id", id);
  };
  const handleChangeBU = (id) => {
    setBUnit(id ? [Number(id)] : []);
    getDepartmentList(id);
  };
  const onDepartment = (id) => {
    setDepartment(id ? [Number(id)] : []);
  };

  const handledelete = (id) => {
    const data = {
      purchaseOrderId: id,
    };
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await instance.post(
            `/customer/purchase-order/delete-past-order`,
            data
          );
          toast.success(response?.data?.message);
          getPurchaseOrderList();
          //  console.log("resposne", response);
        } catch (err) {
          toast.error(err?.response?.data?.message);
        }
      }
    });
  };

  const handleSearch = debounce((text) => {
    setSearchText(text);
  }, 500);

  useEffect(() => {
    filterData();
  }, [searchText, supplier, bUnit, department, startDate, endDate]);

  const filterData = useCallback(async () => {
    //  console.log(
    //   "textttt",
    //   searchText,
    //   supplier,
    //   bUnit,
    //   department,
    //   startDate,
    //   endDate
    // );
    getPurchaseOrderList();
  }, [searchText, supplier, bUnit, department, startDate, endDate]);

  return (
    <div className="container-fluid">
      <div className="dbMain purchase">
        <Leftpanel breadcm="Order" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            breadcm=""
            title="Purchase Orders"
            description=""
          />
          <div className="commonBase">
            <div className="dbtableTop mb-3 poSrch">
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <div className="dbtableSrchbg">
                <button className="commonButton">
                  <Link to="/createpurchaseorder">
                    <i className="fa-solid fa-plus"></i> Create Past Order
                  </Link>
                </button>
                &nbsp;&nbsp;
                {/* <button className="commonButton">
                  <Link to="/pastorderdetail">My Basket(50)</Link>
                </button> */}
              </div>
            </div>
            <div className="dbtableTop">
              &nbsp;
              <div className="dbtableSrchbg">
                <select
                  className="form-control"
                  onChange={(e) => handleDropdown(e.target.value)}
                >
                  <option value="">{t("select_supplier")}</option>

                  {SupplierDataList?.map((d, index) => (
                    <option key={index} value={d?.id}>
                      {d?.name}
                    </option>
                  ))}
                </select>
                &nbsp;
                <select
                  className="form-control"
                  onChange={(e) => handleChangeBU(e.target.value)}
                >
                  <option value="">{t("operating_unit")}</option>

                  {businesUnitData?.map((d) => (
                    <option value={d?.id}>{d?.name}</option>
                  ))}
                </select>
                &nbsp;
                <select
                  className="form-control"
                  onChange={(e) => onDepartment(e.target.value)}
                >
                  <option value="">Select Department</option>
                  {myDepartmentList?.map((d) => (
                    <option value={d?.id}>{d?.name}</option>
                  ))}
                </select>
                &nbsp;
                <div className="dateSelect">
                  <DatePicker
                    selectsStart
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    startDate={startDate}
                    placeholderText="From"
                  />
                  &nbsp;&nbsp;
                  <DatePicker
                    selectsEnd
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    endDate={endDate}
                    startDate={startDate}
                    minDate={startDate}
                    placeholderText="To"
                  />
                </div>
              </div>
            </div>
            {isLoading && <SpinnerComponent isLoading={isLoading} />}

            <Tabs
              defaultActiveKey={"Past Order"}
              id="uncontrolled-tab-example"
              className="supplyerTablink"
              style={{ margin: "10px" }}
              onClick={() => setIsDraft(!isDraft)}
            >
              <Tab eventKey="Past Order" title="Past Order">
                <PurchaseTable
                  allPurchaseData={allPurchaseData}
                  handledelete={handledelete}
                />
              </Tab>
              <Tab eventKey="Saved Baskets" title="Saved Baskets">
                <PurchaseTable
                  allPurchaseData={allPurchaseData}
                  handledelete={handledelete}
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Purchaseorderlist;
